
import React, { useEffect } from 'react';
import { FormGroup, Input, Progress } from 'reactstrap';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { faFileUpload, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import FileBadges from './FileBadges';
import APIResultMessage from 'components/common/APIResultMessage';

function FileUpload({onFilesUpload, showDragAndDropArea, setSearch, fileUpload}) {
    const { response, selectedFiles, fileInputRef, changeFile, dragActive, removeFile, isUploading,
        handleDragEnter, handleDragOver, handleDragLeave, handleDrop, triggerFileUpload, error, success} = fileUpload

    useEffect(() => {
        if (response?.length > 0) {
            console.log('call on file upload')
            onFilesUpload(response)
        }
    }, [response]);

    if(!showDragAndDropArea){
        return (
            <>
                <APIResultMessage success={success} error={error} />
                {fileUpload.isUploading && (
                    <div className="my-2">
                        <Progress value={fileUpload.uploadProgress}>
                            {fileUpload.uploadProgress}%
                        </Progress>
                    </div>
                )}
                {selectedFiles.map((file, index) => (
                    <FileBadges key={index} fileType={file.type} fileName={file.name} handleRemoveFile={() => removeFile(index)}/>
                ))}
                <FormGroup style={{ display: 'none' }}>
                    <Input
                        type="file"
                        onChange={changeFile}
                        disabled={isUploading}
                        innerRef={fileInputRef}
                        multiple
                    />
                </FormGroup>
            </>
        );
    }

    return (
        <div
            className={`w-100 file-upload ${dragActive ? 'active' : ''}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
                border: '2px dashed #ccc',
                borderRadius: '5px',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
            }}
        >
            <APIResultMessage success={success} error={error} />
            {fileUpload.isUploading && (
                <div className="my-2">
                    <Progress value={fileUpload.uploadProgress}>
                        {fileUpload.uploadProgress}%
                    </Progress>
                </div>
            )}
            <Input
                type="file"
                multiple
                id="file-upload-input"
                innerRef={fileInputRef}
                style={{ display: 'none' }}
                onChange={changeFile}
            />
            <IconButtonWithTooltip translationId='uploads.label.dragDrop' icon={faFileUpload} onClick={triggerFileUpload} type="ButtonPrimary"/>
            {setSearch &&
                <IconButtonWithTooltip translationId='uploads.label.search' icon={faMagnifyingGlass} onClick={setSearch} type="ButtonPrimary"/>
            }
            {/*selectedFiles.length > 0 && (
                <ul style={{ marginTop: '10px', listStyleType: 'none' }}>
                    {selectedFiles.map((file, index) => (
                        <li key={index}>{file.name}</li>
                    ))}
                </ul>
            )*/}
            {selectedFiles.map((file, index) => (
                <FileBadges key={index} fileType={file.type} fileName={file.name} handleRemoveFile={() => removeFile(index)}/>
            ))}
        </div>
    );
}

export default FileUpload;
